export const ALLOWED_TERMINAL_IDS: number[] = [1, 209, 4, 153];

export function isCityDeliveryDispatchAllowed(terminalId: number | undefined): boolean {
  return terminalId != null && ALLOWED_TERMINAL_IDS.includes(terminalId);
}
